// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './generated/routes/_app'
import { Route as AppIndexRouteImport } from './generated/routes/_app/index'
import { Route as AppManagementRouteImport } from './generated/routes/_app/management'
import { Route as AppCouponsRouteImport } from './generated/routes/_app/coupons'

const AppRoute = AppRouteImport.update({
            id: '/_app',getParentRoute: () => rootRouteImport
          })
const AppIndexRoute = AppIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppRoute
          })
const AppManagementRoute = AppManagementRouteImport.update({
            id: '/management',path: '/management',getParentRoute: () => AppRoute
          })
const AppCouponsRoute = AppCouponsRouteImport.update({
            id: '/coupons',path: '/coupons',getParentRoute: () => AppRoute
          })





const AppRouteChildren = {
  AppCouponsRoute: AppCouponsRoute,AppManagementRoute: AppManagementRoute,AppIndexRoute: AppIndexRoute
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren = {
  AppRoute: AppRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)